'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var constants = require('./constants.js');

var dataSeriesGenerator = function (theme, goalName, data, goalLine) {
    if (goalLine === void 0) { goalLine = false; }
    var dataSeries = data.map(function (datum, i) {
        return tslib.__assign(tslib.__assign({}, datum), { color: datum.color || constants.colors[i] });
    });
    // This basically fakes a data series as a way to get Highcharts to put the goal
    // plotline (generated in the function below) into the legend.
    if (goalLine) {
        dataSeries.push({
            name: goalName,
            data: [],
            color: theme.palette.success.dark,
        });
    }
    return dataSeries;
};
var plotLineGenerator = function (theme, goal) { return [
    {
        value: goal || 0,
        color: goal ? theme.palette.success.dark : 'rgba(0,0,0,0)',
        dashStyle: 'ShortDot',
        width: 2,
    },
]; };
var generateOptions = function (options, theme) {
    var height = options.height, autorotation = options.autorotation, categories = options.categories, xAxisXOffset = options.xAxisXOffset, xAxisYOffset = options.xAxisYOffset, color = options.color, goal = options.goal, goalName = options.goalName, dataSeries = options.dataSeries, yAxisAddon = options.yAxisAddon, yAxisLabels = options.yAxisLabels, noLegend = options.noLegend, tooltipFormatter = options.tooltipFormatter;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {
        chart: {
            type: 'column',
        },
        legend: {
            itemStyle: {
                font: '15px "TT Commons", Arial, sans-serif',
            },
        },
        title: { text: '' },
        credits: {
            enabled: false,
        },
        marginBottom: 0,
        styledMode: true,
        tooltip: {
            useHTML: true,
            borderRadius: 6,
            borderWidth: 1,
            borderColor: '#D6DCE5',
            backgroundColor: '#FFFFFF',
            style: {
                color: '#6E84A3',
            },
        },
        xAxis: {
            categories: [''],
            crosshair: true,
            labels: {
                style: {
                    color: 'pink',
                    font: 'normal 500 13px "TT Commons", Arial, sans-serif',
                },
                align: 'center',
                autoRotation: [-45],
                y: 30,
                x: -12,
            },
        },
        yAxis: {
            min: 0,
            title: undefined,
            gridLineColor: '#E3EBF6',
            gridLineDashStyle: 'ShortDash',
            plotLines: [
                {
                    value: 0,
                    color: 'rgba(0,0,0,0)',
                    dashStyle: 'ShortDash',
                    width: 2,
                },
            ],
            labels: {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                formatter: function () {
                    return "" + this.value;
                },
                style: {
                    font: 'normal 500 13px "TT Commons", Arial, sans-serif',
                },
            },
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                borderRadius: 4,
                color: '#4C7CFD',
            },
            series: { pointWidth: 7, showInLegend: true },
        },
        series: [{ name: '', data: [0], color: 'rgba(0,0,0,0)' }],
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var formatter = function formatter() {
        // eslint-disable-next-line react/no-this-in-sfc
        return "" + this.value + (yAxisAddon || '');
    };
    if (result.chart)
        result.chart.height = height;
    result.xAxis.categories = categories;
    if (result.xAxis.labels) {
        result.xAxis.labels.autoRotation = autorotation;
        if (result.xAxis.labels.style)
            result.xAxis.labels.style.color = color;
        if (xAxisXOffset || xAxisXOffset === 0)
            result.xAxis.labels.x = xAxisXOffset;
        if (xAxisYOffset || xAxisYOffset === 0)
            result.xAxis.labels.y = xAxisYOffset;
    }
    result.yAxis.plotLines = plotLineGenerator(theme, goal);
    result.series = dataSeriesGenerator(theme, goalName, dataSeries, !!goal);
    if (result.yAxis.labels) {
        result.yAxis.labels.enabled = yAxisLabels;
        result.yAxis.labels.formatter = formatter;
    }
    result.legend = noLegend ? { enabled: false } : constants.legend;
    result.yAxis.gridLineWidth = yAxisLabels ? 1 : undefined;
    if (result.tooltip)
        result.tooltip.formatter = tooltipFormatter;
    return result;
};

exports.dataSeriesGenerator = dataSeriesGenerator;
exports.generateOptions = generateOptions;
exports.plotLineGenerator = plotLineGenerator;
